module.exports = __webpack_public_path__ + "img/adu_5.309afbc2.png";